import React, { useEffect } from "react";

import { Header } from "../header";
import { Footer } from "../footer";
import ButtonToTop from "../buttons/back-to-top";

import * as styles from './index.module.scss';
import '../../styles/index.scss';

export const Layout = ({ children, minimal = false, haveLayout = true }) => {
  // A function to allow CSS env for keyboard height
  useEffect(() => {
    if ("virtualKeyboard" in navigator)
      navigator.virtualKeyboard.overlaysContent = true;
  });
  if (haveLayout)
    return (
      <div>
        {!minimal && <Header />}
        <main className={`${styles.container}`}>
          { children }
        </main>
        <ButtonToTop />
        <Footer />
      </div>
    );
  else
      return (
        <main className={`${styles.container}`}>
          { children }
        </main>
      );
};